/* eslint-disable @scandipwa/scandipwa-guidelines/file-structure */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import { Field } from 'Util/Query';

function _getRegionField() {
    return new Field('region')
        .addFieldList(['label', 'region_id']);
}

function _getCountryField() {
    return new Field('country')
        .addFieldList(['code']);
}

export function addAddressFields(args, callback) {
    return [
        ...callback(...args),
        'city',
        _getCountryField(),
        'firstname',
        'lastname',
        'postcode',
        _getRegionField(),
        'telephone',
        'street'
    ];
}

export default {
    'Query/Cart/Query': {
        'member-function': {
            _getShippingAddressesFields: addAddressFields
        }
    }
};
